import React, {useCallback, useEffect, useState} from 'react';
import {Grid, Paper, Typography, Box, Tabs, Tab} from '@mui/material';
import {makeStyles} from "@mui/styles";
import {FormProvider, useForm} from 'react-hook-form';
import ProfileService from '../services/profile';
import ProfileInquiry from '../components/profile/ProfileInquiry'
import ProfilePreferred from '../components/profile/ProfilePreferred';
import {useNavigate} from "react-router-dom";
import OrdererService from "../services/orderer";
import {changeDocumentTitle} from "../lib";
import { colorPrimary, PageTitle } from '../components';
import { ChangePassword } from '../components/profile/ChangePassword';

const useStyles = makeStyles(() => ({
  paper: {
    padding: 30,
  },
  tab: {
    fontSize: 20
  }
}));

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Env() {
  const classes = useStyles();
  const [profile, setProfile] = useState<any>(null);
  const [orderer, setOrderer] = useState<any>({name: '', phone: ''});
  const category = ["주문 설정", "사용자 정보", "비밀번호 변경"];

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const navigate = useNavigate();
  const methods = useForm();

  const getProfile = useCallback(async () => {
    try {
      const profileService = new ProfileService(navigate)
      const response = await profileService.inquiry();
      setProfile(response.data.profile);
    } catch (e) {
      console.error('failed to handle settlements:', e);
    }
  }, [setProfile]);

  const getAssignees = useCallback(async () => {
    try {
      const ordererService = new OrdererService(navigate);
      const response = await ordererService.getOrdererInfo();
      setOrderer(response.data);
    } catch (e) {
      console.error('failed to handle orderer:', e);
    }
  }, [setOrderer]);


  const onSubmit = async (data: any) => {
    console.log('data:', data)
  }

  useEffect(() => {
    changeDocumentTitle("환경설정");
    queueMicrotask(getProfile)
    queueMicrotask(getAssignees)

  }, [])
  
  return (
    <Paper className={classes.paper}>
      <Box sx={{ width: "1000px" }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          {category.map((v: string, i: number) => {
            return(
              <Tab label={v} {...a11yProps(i)} />    
            )
          })}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
              <ProfilePreferred/>
        </form>
      </FormProvider>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ProfileInquiry profile={profile} orderer={orderer}/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <ChangePassword/>
      </TabPanel>
    </Box>
    </Paper>
  );
}
